import {Component, OnDestroy, OnInit} from '@angular/core';
import {slideToLeft} from "../../animations/router.animations";
import {Router} from "@angular/router";
import {RouterPaths} from "../../config/router-paths.model";
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {PaginationScrollService} from "../../service/pageScroll/paginationScroll.service";
import {AppVersionService} from '../../service/app-version/appVersion.service';
import {PosSettingsService} from "../../service/pos-settings.service";
import {ReferralBonusService} from "../../service/referralBonus.service";
import {ContentDisplayingService} from "../../service/content-displaying.service";
import {PartnerService} from "../../service/partner.service";
import {BitcoinAppService} from "../../service/bitcoin-app/bitcoin-app.service";
import {IframeMessagesService} from "../../service/iframe/iframe-messages.service";
import {MessagesEnum} from "../../service/iframe/enums/messages.enum";
import {BitcoinAppConfig} from "../../shared/bitcoin-app/config/bitcoin-app.config";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: [slideToLeft],
    host: {'[@slideToLeft]': ''}
})
export class HomeComponent implements OnInit, OnDestroy {
    partnerLogo = this.partnerService.getPartnerLogo() ? this.partnerService.getPartnerLogo() : '../assets/images/logo.png';
    // partnerLogo = '';
    menu = false;
    RouterPaths = RouterPaths;

    bitcoinAppIframe = {
      show: false,
      src: '',
      shortName: '',
      loaded: false
    }

  bitcoinAppIframeVisibilitySubscription;
  iframeMessageSubscription;
  pageLoadedTimeout: any;
    constructor(private router: Router,
                private appVersionService: AppVersionService,
                private paginationScrollService: PaginationScrollService,
                private posSettingsService: PosSettingsService,
                private contentDisplayingService: ContentDisplayingService,
                private partnerService: PartnerService,
                private referralBonusService: ReferralBonusService,
                private bitcoinAppService: BitcoinAppService,
                private iframeMessagesService: IframeMessagesService,
                private authenticationService: AuthenticationService) {

    }


    ngOnInit() {
      this.bitcoinAppIframeVisibilitySubscription = this.bitcoinAppService.iframeVisibility.subscribe(val => {
        this.bitcoinAppIframe.loaded = false;
        if (this.pageLoadedTimeout) clearTimeout(this.pageLoadedTimeout);
        if (val) {
          this.bitcoinAppIframe.src = val.src;
          this.bitcoinAppIframe.show = val.show;
          this.bitcoinAppIframe.shortName = val.shortName;

          this.pageLoadedTimeout = setTimeout(() => {
            this.bitcoinAppIframe.loaded = true;
          }, BitcoinAppConfig.popupBtnShowingTimeout);
          if (val.show) {
            this.listenIframeMessage();
          } else {
            this.unlistenIframeMessage();
          }
        }
      });

        // this.partnerLogo = this.partnersService.getLogo();
        // this.partnersService.updatePartnerInfo();
    }

    ngOnDestroy() {
      this.bitcoinAppIframe.loaded = false;
      if (this.bitcoinAppIframeVisibilitySubscription) this.bitcoinAppIframeVisibilitySubscription.unsubscribe();
    }

    listenIframeMessage(): void {
      this.iframeMessagesService.listenIframeMessage();
      this.iframeMessageSubscription = this.iframeMessagesService.getMessage$.subscribe(val => {
        if (val && val.data && val.data.event) {
          if (val.data.event === MessagesEnum.closeFrame) {
            this.bitcoinAppService.hideIframe();
          }
          if (val.data.event === MessagesEnum.paymentComplete) {
            this.bitcoinAppService.requestBalanceUpdating();
          }
          if (val.data.event === MessagesEnum.pageLoaded) {
            this.bitcoinAppIframe.loaded = true;
          }
        }
      })
    }

    unlistenIframeMessage(): void {
      this.iframeMessagesService.unlistenIframeMessage();
      if (this.iframeMessageSubscription) this.iframeMessageSubscription.unsubscribe();
    }

    isCheckOutShown() {
        return this.posSettingsService.getIfPaymentsAvailable();
    }

    isStoreShown() {
        return this.posSettingsService.getStorePageVisibility();
    }

    isContactPage() {
        return this.router.url.includes(this.RouterPaths.contacts);
    }

    isTermsPage() {
        return this.router.url.includes(this.RouterPaths.termsAndConditions);
    }

    isPerksPage() {
        return this.router.url.includes(this.RouterPaths.perks);
    }

    isRewardsPage() {
        return this.router.url.includes(this.RouterPaths.commission);
    }

    showRewardsBlock() {
        return !this.isContactPage() && !this.isTermsPage() && !this.isPerksPage() && !this.isRewardsPage();
    }

    onLogout() {
        this.authenticationService.logout();
        this.router.navigate(['/']);
    }

    onContentScroll($event) {
        this.paginationScrollService.emitContentScroll($event);
    }

    upgradeApp() {
        this.appVersionService.upgradeApp();
    }

    isUserLogged() {
        return this.authenticationService.isUserLogged();
    }

    showReferral() {
        return this.referralBonusService.showReferralPage();
    }

    isSupportShown() {
        return this.posSettingsService.getSupportVisibility();
    }

    showAdditionContent() {
        return this.contentDisplayingService.showAdditionContent();
    }

    hideMenuLoader() {
        return this.posSettingsService.isStorePageVisibilityExist() && this.posSettingsService.isPaymentsVisibilityExist();
    }

    closeBitcoinAppFrame() {
      this.bitcoinAppIframe.shortName = '';
      this.bitcoinAppIframe.loaded = false;
      this.bitcoinAppService.hideIframe();
    }
}
